<template>
  <div class="cnzbb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm">
            <el-form-item label="选择月份">
              <el-date-picker
                v-model="searchForm.time"
                type="month"
                format="yyyy年MM月"
                value-format="yyyy-MM"
                :clearable="false"
                placeholder="选择月">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getData">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button :loading="exportLoading" icon="el-icon-printer" @click="exportData">导出</el-button>
            </el-form-item>
          </el-form>
          <table v-loading="tableLoading" class="tcf-bb-table">
              <tr>
                <th colspan="23" style="font-size: 20px;">乔金斯生产{{tableData.year}}年{{tableData.month}}月产能周报表
                  <div style="float: right;padding-right: 10mm;">单位：万元</div>
                </th>
              </tr>
              <tr>
                <th rowspan="2" style="width: 17mm">日期</th>
                <th colspan="2">车间</th>
                <th colspan="5">木工部</th>
                <th colspan="4">油漆</th>
                <th colspan="4">包装</th>
                <th style="width:14mm;">仓库</th>
                <th colspan="3">发货</th>
                <th colspan="3">库存</th>
              </tr>
              <tr>
                <th style="width:10mm;">预下单</th>
                <th style="width:13mm;">实际接单</th>
                <th style="width:13mm;">计划目标</th>
                <th style="width:13mm;">实际完成</th>
                <th style="width:14mm;">完成率</th>
                <th style="width:12mm;">在制品</th>
                <th style="width:12mm;">未开料</th>
                <th style="width:13mm;">计划目标</th>
                <th style="width:13mm;">实际完成</th>
                <th style="width:14mm;">完成率</th>
                <th style="width:13mm;">在制品</th>
                <th style="width:13mm;">计划目标</th>
                <th style="width:13mm;">实际完成</th>
                <th style="width:14mm;">完成率</th>
                <th style="width:13mm;">在制品</th>
                <th style="width:13mm;">入库</th>
                <th style="width:13mm;">发货合计</th>
                <th style="width:13mm;">杭州发货</th>
                <th style="width:13mm;">温州发货</th>
                <th style="width:13mm;">总库存</th>
                <th style="width:13mm;">杭州</th>
                <th style="width:13mm;">温州</th>
              </tr>
              <tr v-for="item in tableData.produceEnergyVoList">
                <td v-html="item.weekTime"/>
                <td/>
                <td>{{ item.realDown }}</td>
                <td/>
                <td>{{ item.woodReal }}</td>
                <td/>
                <td>{{ item.woodMaking }}</td>
                <td>{{ item.cutting }}</td>
                <td/>
                <td>{{ item.paintReal }}</td>
                <td/>
                <td>{{ item.woodMaking }}</td>
                <td/>
                <td>{{ item.packReal }}</td>
                <td/>
                <td>{{ item.packMaking }}</td>
                <td>{{ item.inStock }}</td>
                <td>{{ item.outStockSum }}</td>
                <td>{{ item.hangOutStock }}</td>
                <td>{{ item.winOutStock }}</td>
                <td>{{ item.stock }}</td>
                <td>{{ item.hangStock }}</td>
                <td>{{ item.wenStock }}</td>
              </tr>
              <tr>
                <td>{{ tableData.month }}月计划达成率</td>
                <td colspan="5"/>
                <td colspan="4"/>
                <td colspan="4"/>
                <td colspan="4"/>
                <td/>
                <td/>
                <td/>
                <td/>
                <td/>
              </tr>
              <tr>
                <td>{{ tableData.month }}月订单准交率</td>
                <td colspan="5"/>
                <td colspan="4"/>
                <td colspan="4"/>
                <td colspan="4"/>
                <td/>
                <td/>
                <td/>
                <td/>
                <td/>
              </tr>
              <tr>
                <td colspan="16" style="font-size: 16px;">乔金斯生产{{ tableData.year }}年{{ tableData.month }}月正单在制（万元）</td>
                <td/>
                <td colspan="4" rowspan="3" style="font-size: 16px;">{{ tableData.month }}月下单(元)</td>
                <td/>
                <td/>
              </tr>
              <tr>
                <td style="font-size: 16px;" rowspan="2">车间</td>
                <td colspan="3">1#</td>
                <td colspan="3">3#</td>
                <td colspan="3">7#</td>
                <td colspan="3">8#</td>
                <td colspan="3">合计</td>
                <td/>
                <td/>
                <td/>
              </tr>
              <tr>
                <td colspan="2">金额</td>
                <td colspan="1">单量</td>
                <td colspan="2">金额</td>
                <td colspan="1">单量</td>
                <td colspan="2">金额</td>
                <td colspan="1">单量</td>
                <td colspan="2">金额</td>
                <td colspan="1">单量</td>
                <td colspan="2">金额</td>
                <td colspan="1">单量</td>
                <td/>
                <td/>
                <td/>
              </tr>
              <tr v-for="(item,index) in tableData.sumVos">
                <td colspan="1">{{ item.time }}</td>
                <td colspan="2">{{ item.firstPrice }}</td>
                <td colspan="1">{{ item.firstTotal }}</td>
                <td colspan="2">{{ item.thirdPrice }}</td>
                <td colspan="1">{{ item.thirdTotal }}</td>
                <td colspan="2">{{ item.sevenPrice }}</td>
                <td colspan="1">{{ item.sevenTotal }}</td>
                <td colspan="2">{{ item.eightPrice }}</td>
                <td colspan="1">{{ item.eightTotal }}</td>
                <td colspan="2">{{ item.sumPrice }}</td>
                <td colspan="1">{{ item.sumTotal }}</td>
                <td/>
                <td colspan="2" v-if="index===0">{{ tableData.month }}月杭州下单</td>
                <td colspan="2" v-if="index===1">{{ tableData.month }}月温州下单</td>
                <td colspan="2" v-if="index===2">设计下单</td>
                <td colspan="2" v-if="index===3">在审订单</td>
                <td colspan="2" v-if="index===4"/>
                <td colspan="2" v-if="index===0">{{ tableData.hangSum }}</td>
                <td colspan="2" v-if="index===1">{{ tableData.wenSum }}</td>
                <td colspan="2" v-if="index===2">{{ tableData.totalSum }}</td>
                <td colspan="2" v-if="index===3"/>
                <td colspan="2" v-if="index===4"/>
                <td/>
                <td/>
              </tr>
          </table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { exportProduceEnergyExcel, getProduceEnergyExcel } from '@/api/tj'
import { dateFormat } from '@/utils/index'

export default {
  name: 'cnzbb',
  data() {
    return {
      searchForm: {
        time: ''
      },
      exportLoading: false,
      tableLoading: false,
      tableData: {}
    }
  },
  computed: {
    user: getUser
  },
  created() {
    const end = new Date()
    const endTime = dateFormat('YYYY-mm', end)
    this.searchForm.time = endTime
    this.getData()
  },
  methods: {
    getData() {
      this.tableLoading = true
      getProduceEnergyExcel({ month: this.searchForm.time }).then(response => {
        for (const item of response.data.produceEnergyVoList) {
          item.weekTime = item.weekTime.replace(' ', '<br/>')
        }
        this.tableData = response.data
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    exportData() {
      this.exportLoading = true
      exportProduceEnergyExcel({ month: this.searchForm.time }).then(response => {
        console.log(response.data)
        const _this = this
        let xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.file_url, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            let blob = this.response
            let a = document.createElement('a')
            a.download = response.data.dName
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            _this.excelLoading = false
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
        this.exportLoading = false
      }).catch(() => {
        this.exportLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .tcf-bb-table{
    width: 100%;
    background-color: #fff;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 13px;
    text-align: center;
    margin-top: 20px;
    tr{
      th{
        border: 1px solid #EBEEF5;
        background: #f6f8fa;
        color: #303133;
        padding: 12px 0;
      }
      td{
        border: 1px solid #EBEEF5;
        color: #303133;
        padding: 12px 0;
      }
      &:hover{
        background: #f3f6f9;
      }
    }
  }
</style>
